export const sideBarWidth = 260;
